"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferType = exports.GolfExtras = exports.PreferredCourseType = exports.TripType = void 0;
var TripType;
(function (TripType) {
    TripType["GOLF_HOTEL"] = "GOLF_HOTEL";
    TripType["GOLF"] = "GOLF";
})(TripType = exports.TripType || (exports.TripType = {}));
var PreferredCourseType;
(function (PreferredCourseType) {
    PreferredCourseType["TOP_RATED"] = "TOP_RATED";
    PreferredCourseType["BEST_VALUE"] = "BEST_VALUE";
    PreferredCourseType["BEST_SELLERS"] = "BEST_SELLERS";
    PreferredCourseType["CUSTOM"] = "CUSTOM";
})(PreferredCourseType = exports.PreferredCourseType || (exports.PreferredCourseType = {}));
var GolfExtras;
(function (GolfExtras) {
    GolfExtras["ALL"] = "ALL";
    GolfExtras["REQUIRED_ONLY"] = "REQUIRED_ONLY";
})(GolfExtras = exports.GolfExtras || (exports.GolfExtras = {}));
var TransferType;
(function (TransferType) {
    TransferType["GOLF"] = "GOLF";
    TransferType["GOLF_AIRPORT"] = "GOLF_AIRPORT";
    TransferType["AIRPORT"] = "AIRPORT";
    TransferType["NONE"] = "NONE";
})(TransferType = exports.TransferType || (exports.TransferType = {}));
